import React from 'react';
import Highlighter from 'react-highlight-words';
import classNames from 'classnames';
import { Badge } from 'react-bootstrap';
import ListSearch from '../list/ListSearch';
import CurrencyItem from '../form/misc/CurrencyItem';
import { statusColors, getStatus } from '../../util/vehicle';

const VehicleSaleSearch = ({ allowStates = [], ...props }) => {
  const renderSuggestion = (suggestion, { query }) => {
    const result = {};

    const style = {
      fontSize: '12px',
    };

    ['itemid', 'Make', 'Model', 'Year', 'Type', 'Customer', 'Customer Name', 'License'].forEach(part => {
      result[part] = suggestion[part];
      if (result[part]) {
        result[part] = (
          <Highlighter
            autoEscape
            highlightClassName="hl"
            searchWords={query.replace(':', '').split(/\s/)}
            textToHighlight={`${suggestion[part]}`}
          />
        );
      }
    });

    ['Status', 'New-Used', 'Total Cost'].forEach(part => (result[part] = suggestion[part]));

    const status = getStatus(result.Status);
    const condition = getStatus(result['New-Used']);

    const allowedStates = ['A', ...allowStates];

    return (
      <div className={classNames({ disabled: !allowedStates.includes(status) })}>
        {result.Status && (
          <>
            <Badge
              className="float-right mt-1"
              style={{ color: '#fff', padding: '3x 5px', backgroundColor: statusColors[status] }}
            >
              {status}
            </Badge>
            <Badge
              className="float-right mt-1 mr-1"
              style={{ color: '#fff', padding: '3x 5px', backgroundColor: statusColors[condition] }}
            >
              {condition}
            </Badge>
          </>
        )}
        <div>
          <b>{result.itemid}</b> ({result.Type})
        </div>
        {(result.Year || result.Make || result.Model) && (
          <div style={style}>
            {result.Year} {result.Make} {result.Model}
          </div>
        )}
        {(result['Customer Name'] || result.Customer) && (
          <div style={style}>
            {result['Customer Name']} ({result.Customer})
          </div>
        )}
        {result.License && <div style={style}>License: {result.License}</div>}
        {result['Total Cost'] && <CurrencyItem>{result['Total Cost']}</CurrencyItem>}
      </div>
    );
  };

  return <ListSearch {...props} allowDisable renderSuggestion={renderSuggestion} />;
};

export default VehicleSaleSearch;
